import Text from 'antd/lib/typography/Text'

export default function Loading() {
    return <Text>Loading...</Text>
}
